import i18n from 'i18next';
import { initReactI18next, Trans } from 'react-i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(
    // lazy load in memory translations
    resourcesToBackend((language, namespace, callback) => {
      import(`./${language}/${namespace}.json`)
        .then((resources) => {
          callback(null, resources);
        })
        .catch((error) => {
          callback(error, null);
        });
    }),
  )
  .use(LanguageDetector)
  .init({
    detection: {
      // order and from where user language should be detected
      order: ['querystring', 'cookie', 'localStorage'],
      // keys or params to lookup language from
      lookupQuerystring: 'i18n',
      lookupCookie: 'iterable_i18n',
      lookupLocalStorage: 'iterable_i18n',
    },
    lowerCaseLng: true,
    fallbackLng: 'en-us',

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    ns: ['common'],
    react: {
      // we might have to wrap our app around a suspense
      // once we start loading the translations remotely
      useSuspense: false,
    },
  });

export default i18n;
export { Trans };
